import * as SL from "slate";
import {
  CustomEditor,
  NumberedList,
  BulletedList,
  getElementsByType,
  getSelectedElements,
  CustomElement
} from "../../../../../duck";

export const toggleList = (
  editor: CustomEditor,
  listType: NumberedList["type"] | BulletedList["type"],
  shouldMakeList: boolean
) => {
  const listItemMarks = getElementsByType(editor, "list-item").pop()?.[0].marks;

  // There is a bugFix in 'withLists' plugin that uses 'normalize'. If we don't add 'withoutNormalizing',
  // then 'normalise' will be called between 'unwrapNodes' and 'wrapNode' which causes an errors in the behavior of the list.
  // You can check this article: https://docs.slatejs.org/concepts/11-normalizing#implications-for-other-code
  SL.Editor.withoutNormalizing(editor, () => {
    SL.Transforms.unwrapNodes(editor, {
      match: n => {
        return (
          !SL.Editor.isEditor(n) &&
          SL.Element.isElement(n) &&
          ["bulleted-list", "numbered-list"].includes(n.type)
        );
      },
      split: true
    });

    if (shouldMakeList) {
      const [selectedElement, path] = getSelectedElements(editor)?.pop() || [];
      if (!selectedElement || !path) return;

      SL.Transforms.setNodes(editor, {
        type: "list-item",
        marks: listItemMarks
      });
      SL.Transforms.wrapNodes(editor, {
        type: listType,
        children: []
      });
    } else {
      SL.Transforms.setNodes<CustomElement>(editor, {
        type: "paragraph"
      });
    }
  });
};
